import React, { FC } from 'react';
import styles from './StepLayout.scss';
import { Box, Button, ButtonProps, Loader, TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation, useOrchestratorState } from '@wix/gg-components/orchestrator';
import { StepParams } from 'types/steps';

export type StepLayoutActionsProps = Props;

type Props = {
  onNext?: () => void;
  shouldSkip?: boolean;
  overrideNext?: (next: () => void) => void;
  nextButtonProps?: Pick<ButtonProps, 'disabled'> & {
    label: string;
    isLoading?: boolean;
  };
};

export const StepLayoutActions: FC<Props> = ({ onNext, nextButtonProps, shouldSkip, overrideNext }) => {
  const { t } = useTranslation();
  const { next, back, canGoBack, canGoNext, skip } = useOrchestratorNavigation();
  const { currentParams } = useOrchestratorState<StepParams>();

  const handlePrimaryButtonClick = () => {
    const nextFn = () => {
      onNext?.();
      return next();
    };
    return overrideNext?.(nextFn) ?? nextFn();
  };

  const handleBackButtonClick = () => {
    back();
  };

  const handleSkipButtonClick = () => {
    skip();
  };

  return (
    <div className={styles.stepLayoutActions}>
      <div className={styles.stepLayoutActionsContent}>
        {canGoBack && !currentParams?.checkpoint ? (
          <TextButton skin="dark" prefixIcon={<ChevronLeft />} onClick={handleBackButtonClick}>
            {t('actions-bar.button.back')}
          </TextButton>
        ) : (
          <div />
        )}
        <div className={styles.stepLayoutActionsForward}>
          {shouldSkip && canGoNext && (
            <TextButton skin="dark" onClick={handleSkipButtonClick}>
              {t('actions-bar.button.skip')}
            </TextButton>
          )}
          {!!nextButtonProps && (
            <Button
              {...nextButtonProps}
              disabled={nextButtonProps.isLoading || nextButtonProps.disabled}
              onClick={handlePrimaryButtonClick}
              skin="dark"
            >
              <Box verticalAlign="middle" gap="10px">
                {nextButtonProps.isLoading && <Loader size="tiny" color="white" />}
                {nextButtonProps.label}
              </Box>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
